// extracted by mini-css-extract-plugin
module.exports = {"chart_start_color":"#000000","gray_color":"#c2c2c2","main_color":"#000000","success_color":"#3fd184","error_color":"#ff6e6e","modal_background":"white"};